<script>
import PageLandingElectricite from '../PageLandingElectricite'

export default {
  name: 'PageLandingElectriciteCHR',

  extends: PageLandingElectricite,

  data() {
    return {
      form_background_filename: 'visuel-fond-questionnaire-hotelier.jpg',
    }
  },
}
</script>
